import {
  CreateProjectRequest,
  ManageProjectRequest,
} from "tng-address-collection-shared/types/apiTypes.ts";

const emptyProjectForm = {
  displayName: "",
  projectShepherds: { group: [], individual: [] },
  projectMembers: { group: [], individual: [] },
  projectSigners: { group: [], individual: [] },
  infoBox: "",
};

export const fallbackCreateProject: CreateProjectRequest = emptyProjectForm;

export const fallbackProject: ManageProjectRequest = {
  ...emptyProjectForm,
  id: "",
};
